import * as i0 from '@angular/core';
import { Injectable, Inject, Component, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, Observable, EMPTY, throwError } from 'rxjs';
import { Utente, ImpostazioniApplicazioni, CODICI_RUOLO, AZIENDA_CORRENTE, MODULI_RUOLO, CODICI_AZIENDA, getInternautaUrl, BaseUrlType } from '@bds/internauta-model';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as i2 from '@bds/common-tools';
import { IntimusCommands } from '@bds/common-tools';
import * as i1$1 from '@angular/router';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import * as i1$2 from '@ng-idle/core';
import { DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import * as i2$1 from '@ng-idle/keepalive';
var LoginType;
(function (LoginType) {
  LoginType[LoginType["Local"] = 0] = "Local";
  LoginType[LoginType["SSO"] = 1] = "SSO";
})(LoginType || (LoginType = {}));
class UtilityFunctions {
  // ritorna il tipo di login in stringa
  static getLoginTypeStringForSessionStorage(loginType) {
    switch (loginType) {
      case LoginType.Local:
        return "local";
      case LoginType.SSO:
        return "sso";
      default:
        return undefined;
    }
  }
  // ritorna il tipo di login dalla stringa
  static getLoginTypeFromSessionStorageString(loginType) {
    switch (loginType) {
      case "local":
        return LoginType.Local;
      case "sso":
        return LoginType.SSO;
      default:
        return undefined;
    }
  }
  // creazione dell'utente loggato a partire da UserInfo
  static buildLoggedUser(userInfo) {
    const loggedUser = new Utente();
    for (const key in userInfo) {
      if (userInfo.hasOwnProperty(key)) {
        loggedUser[key] = userInfo[key];
      }
    }
    return loggedUser;
  }
  static manageChangeUserLogin(params, loginService, router, loginRoute) {
    // debugger;
    console.log("dentro subscribe, ", params.hasOwnProperty("impersonatedUser"));
    console.log("chiamo login");
    console.log("impersonateUser: ", params["impersonatedUser"], "on azienda: ", params["aziendaImpersonatedUser"], "with code: ", params["code"]);
    if (params.hasOwnProperty("passToken")) {
      console.log("setto passToken");
      loginService.passToken = params["passToken"].trim();
    }
    if (params.hasOwnProperty("from")) {
      loginService.from = params["from"].trim();
    }
    if (params.hasOwnProperty("code")) {
      loginService.code = params["code"].trim();
    }
    // se nei params c'è la proprietà impersonatedUser, allora pulisci la sessione, setta nella sessionStorage l'utente impersonato
    // e cancellalo dai params
    if (params.hasOwnProperty("impersonatedUser")) {
      loginService.clearSession();
      // tslint:disable-next-line:max-line-length
      loginService.setimpersonatedUser(params["impersonatedUser"].trim(), params["realUser"] ? params["realUser"].trim() : null, params["aziendaImpersonatedUser"] ? params["aziendaImpersonatedUser"].trim() : null);
      // devi risettare il passtoken se c'è perché il clearSession() lo toglie
      if (params.hasOwnProperty("passToken")) {
        console.log("setto passToken");
        loginService.passToken = params["passToken"].trim();
      }
      // eliminazione dai query params di impersonatedUser
      // this.loginService.redirectTo = this.router.routerState.snapshot.url.replace(/(?<=&|\?)impersonatedUser(=[^&]*)?(&|$)/, "");
      const currentUrl = router.routerState.snapshot.url;
      // if (!currentUrl || currentUrl === "") {
      //   currentUrl = location.pathname + location.search;
      // }
      loginService.redirectTo = UtilityFunctions.removeQueryParams(currentUrl, "realUser");
      loginService.redirectTo = UtilityFunctions.removeQueryParams(loginService.redirectTo, "impersonatedUser");
      loginService.redirectTo = UtilityFunctions.removeQueryParams(loginService.redirectTo, "aziendaImpersonatedUser");
      console.log("STATE: ", loginService.redirectTo);
      router.navigate([loginRoute]);
    }
    if (window.location.href && window.location.href !== "" && params.hasOwnProperty("passToken")) {
      window.history.replaceState(null, document.title, UtilityFunctions.removeQueryParams(window.location.href, "passToken"));
    }
    if (window.location.href && window.location.href !== "" && params.hasOwnProperty("realUser")) {
      window.history.replaceState(null, document.title, UtilityFunctions.removeQueryParams(window.location.href, "realUser"));
    }
    if (window.location.href && window.location.href !== "" && params.hasOwnProperty("impersonatedUser")) {
      window.history.replaceState(null, document.title, UtilityFunctions.removeQueryParams(window.location.href, "impersonatedUser"));
    }
    if (window.location.href && window.location.href !== "" && params.hasOwnProperty("aziendaImpersonatedUser")) {
      window.history.replaceState(null, document.title, UtilityFunctions.removeQueryParams(window.location.href, "aziendaImpersonatedUser"));
    }
  }
  /**
   * rimuove dall'url il query param passato
   * @param url
   * @param paramToRemove query param da rimuovere
   */
  static removeQueryParams(url, paramToRemove) {
    const splittedUrl = url.split("?");
    if (splittedUrl.length === 1) {
      return url;
    }
    let purgedQueryParams = "";
    const queryParams = splittedUrl[1];
    const splittedQueryParams = queryParams.split("&");
    for (let i = 0; i < splittedQueryParams.length; i++) {
      const splittedQueryParam = splittedQueryParams[i].split("=");
      if (splittedQueryParam[0] !== paramToRemove) {
        purgedQueryParams += splittedQueryParams[i] + "&";
      }
    }
    if (purgedQueryParams !== "") {
      return splittedUrl[0] + "?" + purgedQueryParams.substr(0, purgedQueryParams.length - 1);
    } else {
      return splittedUrl[0];
    }
  }
}
class UtenteUtilities {
  utente;
  loginConfig;
  loginService;
  http;
  constructor(utente, loginService, loginConfig, http) {
    this.utente = utente;
    this.loginConfig = loginConfig;
    this.loginService = loginService;
    this.http = http;
  }
  getUtente() {
    return this.utente;
  }
  /**
   * torna le impostazioni dell'utente dell'applicazione corrente
   * (nel caso di cambio utente vengono tornate quelle dell'utente reale (del primo login))
   */
  getImpostazioniApplicazione() {
    let utenteDaUsare;
    if (this.utente.utenteReale) {
      utenteDaUsare = this.utente.utenteReale;
    } else {
      utenteDaUsare = this.utente;
    }
    const impostazioniApplicazioni = utenteDaUsare.idPersona.impostazioniApplicazioniList;
    if (impostazioniApplicazioni && impostazioniApplicazioni.length === 1) {
      return impostazioniApplicazioni[0];
    } else {
      return null;
    }
  }
  setImpostazioniApplicazione(loginService, impostazioniVisualizzazione) {
    let utenteDaUsare;
    if (this.utente.utenteReale) {
      utenteDaUsare = this.utente.utenteReale;
    } else {
      utenteDaUsare = this.utente;
    }
    if (!utenteDaUsare.idPersona.impostazioniApplicazioniList || utenteDaUsare.idPersona.impostazioniApplicazioniList.length === 0) {
      const impostazioni = new ImpostazioniApplicazioni();
      impostazioni.impostazioniVisualizzazione = JSON.stringify(impostazioniVisualizzazione);
      utenteDaUsare.idPersona.impostazioniApplicazioniList = [];
      utenteDaUsare.idPersona.impostazioniApplicazioniList.push(impostazioni);
    } else {
      // tslint:disable-next-line:max-line-length
      utenteDaUsare.idPersona.impostazioniApplicazioniList[0].impostazioniVisualizzazione = JSON.stringify(impostazioniVisualizzazione);
    }
    this.sendImpostazioniApplicazioni(impostazioniVisualizzazione).subscribe(res => {
      loginService.setLoggedUser$(this.utente, true);
      this.loginService.settingsChangedNotifier$.next(impostazioniVisualizzazione);
    });
    return this.loginService.settingsChangedNotifier$.asObservable();
  }
  sendImpostazioniApplicazioni(impostazioniVisualizzazione) {
    const url = this.loginConfig.setImpostazioniApplicazioniUrl;
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };
    return this.http.post(url, impostazioniVisualizzazione, options);
  }
  get settingsChangedNotifier$() {
    return this.loginService.settingsChangedNotifier$.asObservable();
  }
  /**
   * funzione che mi dice se ho quel ruolo per quell'azienda
   * se l'azienda è null controllo se ha quel ruolo per almento un azienda
   * se viene passata l'azienda considero l'utente di quell'azienda (se esiste)
   * @param ruolo dev'essere un valore della costante CODICI_RUOLO
   * @param azienda dev'essere un codice di azienda (ad es 102, 105, ...) oppure la costanete AZIENDA_CORRENTE
   */
  hasRole(ruolo, azienda) {
    if (ruolo === CODICI_RUOLO.CI || ruolo === CODICI_RUOLO.AS || ruolo === CODICI_RUOLO.SD) {
      // è un ruolo interaziendale
      if (this.utente.ruoliUtentiPersona && this.utente.ruoliUtentiPersona[ruolo]) {
        return true;
      } else {
        return false;
      }
    } else {
      // è un ruolo aziendale
      if (!azienda) {
        // se non passo l'azienda controllo se ha quel ruolo per un azienda qualsiasi
        if (this.utente.ruoliUtentiPersona && this.utente.ruoliUtentiPersona[ruolo]) {
          return true;
        } else {
          return false;
        }
      } else if (azienda === AZIENDA_CORRENTE) {
        azienda = this.utente.aziendaLogin.codice;
      }
      if (this.utente.ruoliUtentiPersona && !!this.utente.ruoliUtentiPersona[azienda]) {
        const ruoli = this.utente.ruoliUtentiPersona[azienda][MODULI_RUOLO.GENERALE];
        return !!ruoli.find(e => e === ruolo);
      } else {
        return false;
      }
    }
  }
  /**
   * funzione che mi dice se il un permesso di flusso per un'azienda
   * @param codiceAzienda dev'essere un codice di azienda (ad es 102, 105, ...) oppure la costanete AZIENDA_CORRENTE
   * @param permission dev'essere un valore del enum FluxPermssion
   */
  hasFluxPermission(codiceAzienda, permission) {
    if (codiceAzienda === AZIENDA_CORRENTE) {
      codiceAzienda = this.utente.idAzienda.codice;
    }
    const permessiESPAzienda = this.utente.permessiDiFlussoByCodiceAzienda[codiceAzienda];
    if (!permessiESPAzienda || permessiESPAzienda.length === 0) {
      return false;
    }
    for (const permessoEntita of permessiESPAzienda) {
      for (const categoria of permessoEntita.categorie) {
        for (const permesso of categoria.permessi) {
          if (permesso.predicato === permission) {
            return true;
          }
        }
      }
    }
    return false;
  }
  /**
   * funzione che mi dice tutti i permessi di flusso in un array per un'azienda
   * @param codiceAzienda dev'essere un codice di azienda (ad es 102, 105, ...) oppure la costanete AZIENDA_CORRENTE
   */
  getFluxPermissionByAzienda(codiceAzienda) {
    if (codiceAzienda === AZIENDA_CORRENTE) {
      codiceAzienda = this.utente.idAzienda.codice;
    }
    const predicatiPermessi = [];
    const permessiESPAzienda = this.utente.permessiDiFlussoByCodiceAzienda[codiceAzienda];
    if (!permessiESPAzienda || permessiESPAzienda.length === 0) {
      return [];
    }
    for (const permessoEntita of permessiESPAzienda) {
      for (const categoria of permessoEntita.categorie) {
        for (const permesso of categoria.permessi) {
          if (!predicatiPermessi.some(predicato => predicato == permesso.predicato)) {
            predicatiPermessi.push(permesso.predicato);
          }
        }
      }
    }
    return predicatiPermessi;
  }
  /**
   * funzione che mi dice se il un array di codici azienda, delle aziende dove ho il permesso di flusso passato
   * @param permission dev'essere un valore del enum FluxPermssion
   */
  getAziendeWithPermission(permission) {
    const result = [];
    for (const key in CODICI_AZIENDA) {
      if (this.hasFluxPermission(CODICI_AZIENDA[key], permission)) {
        result.push(CODICI_AZIENDA[key]);
      }
    }
    return result;
  }
  /**
   * Torna i permessi pec dell'utente nel seguente formato:
   * {
   *  IdPec: [PecPermission1, PecPermission2", ...], //es. LEGGE, ELIMINA, ...
   *  ....
   * }
   */
  getPecPermissions() {
    return this.getUtente().idPersona.permessiPec;
  }
  /**
   * Torna se la persona dell'utente corrente ha il permesso passato sulla pec passata
   * @param idPec la pec
   * @param pecPermission il permesso
   */
  hasPecPermission(idPec, pecPermission) {
    const pecPermissions = this.getPecPermissions();
    if (pecPermissions && pecPermissions[idPec]) {
      return pecPermissions[idPec].find(p => p === pecPermission) != null;
    } else {
      return false;
    }
  }
  /**
   * Torna la lista delle pec con il permesso passato
   * @param pecPermission
   */
  getPecsWithPermission(pecPermission) {
    const pecPermissions = this.getPecPermissions();
    const res = [];
    if (pecPermissions) {
      Object.keys(pecPermissions).forEach(key => {
        const idPec = Number(key);
        const permissions = pecPermissions[idPec];
        if (pecPermission && permissions.find(p => p === pecPermission)) {
          res.push(idPec);
        }
      });
    }
    return res;
  }
  isUserChanged() {
    return this.utente.utenteReale !== null;
  }
  // DEPRECATE usare la hasRole()
  isUG() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.UG]);
  }
  isMOS() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.MOS]);
  }
  isOS() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.OS]);
  }
  isCA() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.CA]);
  }
  isCI() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.CI]);
  }
  isAS() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.AS]);
  }
  isSD() {
    let ruoli = null;
    if (this.utente.utenteReale) {
      ruoli = this.utente.utenteReale.mappaRuoli[MODULI_RUOLO.GENERALE];
    } else {
      ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    }
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.SD]);
  }
  isRV() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.RV]);
  }
  isIP() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.IP]);
  }
  isAG() {
    const ruoli = this.utente.mappaRuoli[MODULI_RUOLO.GENERALE];
    return !!ruoli.find(e => e["nomeBreve"] === RUOLI[RUOLI.AG]);
  }
}
// TODO: eliminare. Usere codici ruolo nel file Ruolo.ts
var RUOLI;
(function (RUOLI) {
  RUOLI[RUOLI["UG"] = 0] = "UG";
  RUOLI[RUOLI["MOS"] = 1] = "MOS";
  RUOLI[RUOLI["OS"] = 2] = "OS";
  RUOLI[RUOLI["CA"] = 3] = "CA";
  RUOLI[RUOLI["CI"] = 4] = "CI";
  RUOLI[RUOLI["AS"] = 5] = "AS";
  RUOLI[RUOLI["SD"] = 6] = "SD";
  RUOLI[RUOLI["RV"] = 7] = "RV";
  RUOLI[RUOLI["IP"] = 8] = "IP";
  RUOLI[RUOLI["AG"] = 9] = "AG";
})(RUOLI || (RUOLI = {}));
class JwtLoginService {
  loginConfig;
  http;
  intimusClientService;
  _token;
  _passToken;
  _loginMethod;
  _redirectTo;
  _loggedUser$ = new BehaviorSubject(null);
  _isUserImpersonated = false;
  _from;
  _settingsChangedNotifier$ = new Subject();
  logoutUrlTemplate;
  subscriptions = [];
  intimusSubscribbed = false;
  _newUserAccess = true;
  _code;
  get newUserAccess() {
    return this._newUserAccess;
  }
  set newUserAccess(newUserAccess) {
    this._newUserAccess = newUserAccess;
  }
  get code() {
    return this._code;
  }
  set code(code) {
    this._code = code;
  }
  constructor(loginConfig, http, intimusClientService) {
    this.loginConfig = loginConfig;
    this.http = http;
    this.intimusClientService = intimusClientService;
    // si sottoscrive a intimus una volta che l'utente è connesso
    this.subscriptions.push(this._loggedUser$.subscribe(u => {
      if (u) {
        // this.utenteUtilities = u;
        if (!this.intimusSubscribbed) {
          this.subscriptions.push(this.intimusClientService.command$.subscribe(command => {
            if (command.command === IntimusCommands.Logout) {
              this._logout(this.loginConfig.logoutRedirectRoute);
            }
          }));
          this.intimusSubscribbed = true;
        }
      }
    }));
  }
  get loggedUser$() {
    return this._loggedUser$.asObservable();
  }
  setLoggedUser$(loggedUser, force = false) {
    console.log("Dentro setLoggedUser$", loggedUser, force);
    if (loggedUser && (force || !this._loggedUser$.getValue())) {
      const jsonParametri = loggedUser.aziendaLogin.parametriMap;
      this.logoutUrlTemplate = jsonParametri["logoutUrl"];
      this._loggedUser$.next(new UtenteUtilities(loggedUser, this, this.loginConfig, this.http));
      sessionStorage.setItem("loggedUser", JSON.stringify(loggedUser));
    } else if (this._loggedUser$.getValue() && !loggedUser) {
      console.log("Svuoto il _loggedUser$");
      this._loggedUser$.next(null);
      sessionStorage.removeItem("loggedUser");
    }
  }
  /**
   * setta l'url assoluto del login, è necessario perchè altrimenti nel caso in cui l'url non è costante
   * non si riesce a calcolarlo all'avvio e si va a settare quindi nell'ngOnInit dell'AppComponent
   */
  setLoginUrl(url) {
    this.loginConfig.loginURL = url;
  }
  /**
   * setta l'url assoluto della servlet che genera il passToken, è necessario perchè altrimenti nel caso in cui l'url non è costante
   * non si riesce a calcolarlo all'avvio e si va a settare quindi nell'ngOnInit dell'AppComponent
   */
  setPassTokenGeneratorURL(url) {
    this.loginConfig.passTokenGeneratorURL = url;
  }
  /**
   * setta l'url assoluto della servlet che viene chiamata dall'applicazione principale per indicare al backend che non si è in IDLE;
   * è necessario perchè altrimenti nel caso in cui l'url non è costante
   * non si riesce a calcolarlo all'avvio e si va a settare quindi nell'ngOnInit dell'AppComponent
   */
  setRefreshSessionInternautaUrl(url) {
    this.loginConfig.refreshSessionInternautaUrl = url;
  }
  getRefreshSessionInternautaUrl() {
    return this.loginConfig.refreshSessionInternautaUrl;
  }
  /**
   * setta l'url assoluto della servlet che scrive le impostazioni dell'applicazione su BD,
   * è necessario perchè altrimenti nel caso in cui l'url non è costante
   * non si riesce a calcolarlo all'avvio e si va a settare quindi nell'ngOnInit dell'AppComponent
   */
  setImpostazioniApplicazioniUrl(url) {
    this.loginConfig.setImpostazioniApplicazioniUrl = url;
  }
  get isUserImpersonated() {
    return this._isUserImpersonated;
  }
  set isUserImpersonated(val) {
    this._isUserImpersonated = val;
  }
  get token() {
    return this._token;
  }
  set token(token) {
    this._token = token;
  }
  get passToken() {
    return this._passToken;
  }
  set passToken(passToken) {
    this._passToken = passToken;
  }
  get loginMethod() {
    return this._loginMethod;
  }
  set loginMethod(loginMethod) {
    this._loginMethod = loginMethod;
  }
  get redirectTo() {
    return this._redirectTo;
  }
  get from() {
    return this._from;
  }
  set from(value) {
    this._from = value;
  }
  set redirectTo(redirectTo) {
    this._redirectTo = redirectTo;
  }
  setimpersonatedUser(impersonatedUser, realUser, aziendaImpersonatedUser) {
    if (impersonatedUser) {
      sessionStorage.setItem("impersonatedUser", impersonatedUser);
      sessionStorage.setItem("realUser", realUser);
      sessionStorage.setItem("aziendaImpersonatedUser", aziendaImpersonatedUser);
    } else {
      sessionStorage.removeItem("impersonatedUser");
      sessionStorage.removeItem("realUser");
      sessionStorage.removeItem("aziendaImpersonatedUser");
    }
  }
  getImpersonateUser() {
    let val = sessionStorage.getItem("impersonatedUser");
    if (val && val === "") {
      val = null;
    }
    return val;
  }
  getAziendaImpersonateUser() {
    let val = sessionStorage.getItem("aziendaImpersonatedUser");
    if (val && val === "") {
      val = null;
    }
    return val;
  }
  getRealUser() {
    let val = sessionStorage.getItem("realUser");
    if (val && val === "") {
      val = null;
    }
    return val;
  }
  getMainApp() {
    return this.loginConfig.mainApp;
  }
  // pulitura delle variabili di sessione
  clearSession() {
    this._token = null;
    this._passToken = null;
    this._loginMethod = null;
    this._redirectTo = null;
    this._newUserAccess = true;
    sessionStorage.setItem("token", "");
    sessionStorage.setItem("loggedUser", "");
    sessionStorage.setItem("loginMethod", "");
    sessionStorage.setItem("redirectTo", "");
    sessionStorage.setItem("reloadLoggedUser", "");
    sessionStorage.setItem("newUserAccess", "");
    sessionStorage.removeItem("alreadyRedirect");
    this.setLoggedUser$(null);
  }
  // richiesta di login
  // tslint:disable-next-line:max-line-length
  login(loginType, username = null, password = null, realUser = null, idAzienda = null, passToken, code) {
    switch (loginType) {
      case LoginType.Local:
        return this.loginLocal(username, password, realUser, passToken);
      case LoginType.SSO:
        return this.loginSSO(username, idAzienda, passToken, code);
    }
  }
  _logout(logoutRedirectRoute, disableCloseWindows = false) {
    if (this.loginMethod !== LoginType.SSO) {
      this.clearSession();
      window.location.reload();
    } else {
      // prende l'url di logout dall'azienda dell'utente loggato
      this.clearSession();
      const lastSlash = window.location.href.lastIndexOf("/");
      if (this.loginConfig.loggedOutComponentRoute && this.loginConfig.loggedOutComponentRoute !== "") {
        const logoutUrl = window.location.href.substring(0, lastSlash) + this.loginConfig.loggedOutComponentRoute;
        window.location.href = logoutUrl;
      } else {
        const returnUrl = window.location.href.substring(0, lastSlash) + logoutRedirectRoute;
        window.location.href = this.logoutUrlTemplate.replace("[return-url]", returnUrl);
      }
    }
  }
  logout(logoutRedirectRoute, disableCloseWindows = false) {
    if (!disableCloseWindows && (this.isUserImpersonated || this.from && this.from !== "")) {
      this.clearSession();
      window.close();
    } else {
      const logoutUrl = getInternautaUrl(BaseUrlType.LogoutApi) + "?redirectUrl=" + getInternautaUrl(BaseUrlType.Logout);
      this.http.get(logoutUrl, {
        params: {
          application: this.loginConfig.applicazione
        }
      }).subscribe();
    }
  }
  // richiesta di login con SSO in GET
  loginSSO(impersonatedUser = null, idAzienda = null, passToken, code) {
    // debugger
    let requestParams = new HttpParams();
    console.log("passToken1: ", passToken);
    // se ho passanto utente impersonato bisogna inserirlo nella richiesta
    requestParams = requestParams.append("application", this.loginConfig.applicazione);
    if (idAzienda) {
      requestParams = requestParams.append("azienda", idAzienda);
    }
    if (impersonatedUser) {
      requestParams = requestParams.append("impersonatedUser", impersonatedUser);
    }
    if (passToken) {
      requestParams = requestParams.append("passToken", passToken);
    }
    if (code) {
      requestParams = requestParams.append("code", code);
    }
    requestParams = requestParams.append("newUserAccess", (!!this._newUserAccess).toString());
    return new Observable(observer => {
      this.http.get(this.loginConfig.loginURL, {
        params: requestParams,
        observe: "response"
      }).subscribe(data => {
        if (data.status == 201) {
          window.location.href = data.headers.get("Location");
        } else {
          observer.next(this.setDataLogin(data.body, LoginType.SSO));
        }
      }, err => {
        console.log("error", err);
        observer.error(err);
      });
    });
  }
  // richiesta di login in POST, usata per fare login se si è in locale
  loginLocal(username, password, realUser, passToken) {
    console.log("passToken: ", passToken);
    return new Observable(observer => {
      this.http.post(this.loginConfig.loginURL, {
        username: username,
        password: password,
        realUser: realUser,
        application: this.loginConfig.applicazione,
        passToken: passToken,
        newUserAccess: !!this._newUserAccess
      }).subscribe(data => {
        observer.next(this.setDataLogin(data, LoginType.Local));
      }, err => {
        observer.error(err);
      });
    });
  }
  // setting dei dati nelle variabili e nella sessione con utente loggato
  setDataLogin(data, loginMethod) {
    const loggedUser = UtilityFunctions.buildLoggedUser(data.userInfo);
    this.token = data.token;
    this._loginMethod = loginMethod;
    this._newUserAccess = false;
    sessionStorage.setItem("loginMethod", UtilityFunctions.getLoginTypeStringForSessionStorage(loginMethod));
    sessionStorage.setItem("token", data.token);
    sessionStorage.setItem("loggedUser", JSON.stringify(data.userInfo));
    sessionStorage.setItem("newUserAccess", this._newUserAccess.toString());
    // this.setimpersonatedUser(loggedUser.username);
    return loggedUser;
  }
  get settingsChangedNotifier$() {
    return this._settingsChangedNotifier$;
  }
  /**
   * Genera il link per aprire una nuova finestra aggiungendo il passToken
   * @param initialUrl url iniziale da manipolare
   * @param addRichiestaParams indica se aggiungere il parametro richeista=<uuid> che serve alle applicazioni inde
   *  (passare true solo se il link apre un applicazione INDE). Default false.
   * @param openWindow: indica se la funzione apre anche la nuova finestra. Default true.
   */
  // tslint:disable-next-line:max-line-length
  buildInterAppUrl(initialUrl, encodeParams, addRichiestaParam, addPassToken, openWindow, saveAndRestoreLoggedUser = true) {
    let concatChar = initialUrl.indexOf("?") < 0 ? "?" : "&";
    let url = initialUrl;
    if (addRichiestaParam) {
      if (encodeParams) {
        url += encodeURIComponent(concatChar + "richiesta=" + this.myRandomUUID());
      } else {
        url += concatChar + "richiesta=" + this.myRandomUUID();
      }
      concatChar = "&";
    }
    return new Observable(observer => {
      if (addPassToken) {
        this.http.get(this.loginConfig.passTokenGeneratorURL, {
          responseType: "text"
        }).subscribe(passToken => {
          if (openWindow) {
            let reloadLoggedUserValue;
            if (saveAndRestoreLoggedUser) {
              /* bisogna eliminare la chiave "reloadLoggedUser" dal sessionStorage prima di aprire la finsestra per far si
               *  che venga ricaricato l'utente nella nuova applicazione, altrimenti eredità i valori dalla scrivania */
              reloadLoggedUserValue = sessionStorage.getItem("reloadLoggedUser");
              sessionStorage.removeItem("reloadLoggedUser");
            }
            if (encodeParams) {
              url += encodeURIComponent(concatChar + "passToken=" + passToken);
            } else {
              url += concatChar + "passToken=" + passToken;
            }
            window.open(url);
            if (saveAndRestoreLoggedUser) {
              sessionStorage.setItem("reloadLoggedUser", reloadLoggedUserValue);
            }
          }
          observer.next(url);
        });
      } else {
        if (openWindow) {
          window.open(url);
        }
        observer.next(url);
      }
    });
  }
  /**************************
   ** SuperSaloRollsTheUUID **
   **************************/
  myRandomUUID() {
    // 8 - 4 - 4 - 4 - 16
    return this.fourRandomChar() + this.fourRandomChar() +
    // 8
    "-" + this.fourRandomChar() + "-" + this.fourRandomChar() + "-" +
    // -4-4-4-
    this.fourRandomChar() + this.fourRandomChar() + this.fourRandomChar(); // 16
  }
  fourRandomChar() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  ngOnDestroy() {}
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtLoginService,
    deps: [{
      token: "loginConfig"
    }, {
      token: i1.HttpClient
    }, {
      token: i2.IntimusClientService
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtLoginService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: JwtLoginService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ["loginConfig"]
    }]
  }, {
    type: i1.HttpClient
  }, {
    type: i2.IntimusClientService
  }]
});
class JwtLoginComponent {
  httpClient;
  router;
  loginService;
  loginConfig;
  loginURL;
  errorMessage = "";
  showLoading = true;
  showLoginMask = false;
  showErrorLogin = false;
  impersonatedUser;
  aziendaImpersonatedUser;
  realUser;
  passToken;
  constructor(httpClient, router, loginService, loginConfig) {
    this.httpClient = httpClient;
    this.router = router;
    this.loginService = loginService;
    this.loginConfig = loginConfig;
    console.log("constructor() JwtLoginComponent");
  }
  ngOnInit() {
    console.log("onInit() JwtLoginComponent");
    // setting degli URL host e porta per effettuare il login
    if (this.loginConfig.loginURL) {
      this.loginURL = this.loginConfig.loginURL;
    } else {
      const hostname = window.location.hostname;
      const port = hostname === "localhost" ? ":" + this.loginConfig.localhostPort : ":443";
      this.loginURL = window.location.protocol + "//" + hostname + port + this.loginConfig.relativeURL;
    }
    // console.log("stampo impersonatedUser", sessionStorage.getItem("impersonatedUser"));
    // controllo se deve essere effettuato il login con il cambia utente oppure un login "normale"
    this.impersonatedUser = this.loginService.getImpersonateUser();
    this.aziendaImpersonatedUser = this.loginService.getAziendaImpersonateUser();
    this.realUser = this.loginService.getRealUser();
    this.passToken = this.loginService.passToken;
    console.log("onInit() JwtLoginComponent passtoken: ", this.passToken);
    if (this.impersonatedUser) {
      // effettua il login passando l'utente impersonato
      console.log("impersonatedUser: ", this.impersonatedUser, " aziendaImpersonatedUser", this.aziendaImpersonatedUser);
      console.log("sto per eseguire il doLogin per cambio utente...");
      this.doLogin(this.impersonatedUser, this.aziendaImpersonatedUser, this.passToken, null);
      // eliminazione dalla session storage dell'utente impersonato
      // console.log("setto impersonatedUser a '' ");
      // this.loginService.setimpersonatedUser(null, null);
      this.loginService.isUserImpersonated = true;
    } else {
      console.log("sto per eseguire il doLogin senza cambio utente...");
      this.doLogin(null, null, this.passToken, this.loginService.code);
    }
    //   this.route.queryParams.subscribe((params: Params) => {
    //     console.log("dentro subscribe, ", params.hasOwnProperty('impersonatedUser'));
    //       console.log("chiamo login");
    //       console.log(params['impersonatedUser']);
    //       if (params.hasOwnProperty('impersonatedUser')) {
    //         //this.loginService.redirectTo = "/scrivania";
    //         this.loginService.clearSession();
    //         delete params['impersonatedUser'];
    //         this.doLogin(params['impersonatedUser']);
    //       } else {
    //         this.doLogin();
    //       }
    //  });
  }
  // effettua il login: se impersonatedUser != null allora si sta facendo il cambia utente
  doLogin(impersonatedUser = null, idAzienda = null, passToken, code) {
    // prova a fare login usando SSO
    this.loginService.login(LoginType.SSO, impersonatedUser, null, null, idAzienda, passToken, code).subscribe(utente => {
      // mostra form per login in POST
      this.showLoginMask = false;
      this.execRedirect();
      console.log("Login effettuato nella doLogin. ImpersontedUser: " + impersonatedUser, utente);
      if (utente) {
        this.loginService.setLoggedUser$(utente);
      }
    }, err => {
      this.showLoading = false;
      // mostra il form per fare il login in POST
      // if (err.status === 422 && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) {
      if (err.status === 422) {
        // torno 422 se il login con shibboleth non è attivo oppure è attivo, ma non si riesce ad autenticare
        this.showErrorLogin = false;
        this.showLoginMask = true;
      } else {
        this.showErrorLogin = true;
        this.showLoginMask = false;
      }
    });
  }
  // effettua il login in POST con i dati compilati nel form presentato all'utente
  loginPost(form) {
    this.errorMessage = "";
    // tslint:disable-next-line:max-line-length
    this.loginService.login(LoginType.Local, form.value.username, form.value.password, form.value.realUser, null, this.passToken, null).subscribe(utente => {
      this.execRedirect();
      this.loginService.setLoggedUser$(utente);
    }, err => {
      this.errorMessage = "Errore: credenziali errate o utente non abilitato";
    });
  }
  // esegui il redirect
  execRedirect() {
    const redirectTo = this.loginService.redirectTo;
    if (redirectTo) {
      sessionStorage.removeItem("redirectTo");
      this.router.navigateByUrl(redirectTo);
    } else {
      this.router.navigate([this.loginConfig.homeComponentRoute], {
        queryParams: {
          reset: true
        }
      });
    }
  }
  ngOnDestroy() {
    console.log("onDestroy() JwtLoginComponent");
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtLoginComponent,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i1$1.Router
    }, {
      token: JwtLoginService
    }, {
      token: "loginConfig"
    }],
    target: i0.ɵɵFactoryTarget.Component
  });
  /** @nocollapse */
  static ɵcmp = i0.ɵɵngDeclareComponent({
    minVersion: "14.0.0",
    version: "19.0.6",
    type: JwtLoginComponent,
    isStandalone: false,
    selector: "lgn-jwt-login",
    ngImport: i0,
    template: "<div>\r\n  <div\r\n    *ngIf=\"showLoading\"\r\n    class=\"middleDiv\"\r\n  >\r\n    <div>Accesso in corso, attendere...</div>\r\n  </div>\r\n</div>\r\n\r\n<div>\r\n  <div\r\n    *ngIf=\"showLoginMask\"\r\n    class=\"middleDiv\"\r\n  >\r\n    <form\r\n      #loginForm=\"ngForm\"\r\n      (ngSubmit)=\"loginPost(loginForm)\"\r\n    >\r\n      <!-- <div class=\"form-group\">\r\n                <label for=\"inputRealUser\">RealUser</label>\r\n                <input type=\"text\" name=\"realUser\" class=\"form-control\" id=\"inputRealUser\" placeholder=\"RealUser\" [(ngModel)] = \"realUser\">\r\n            </div> -->\r\n      <div class=\"form-group\">\r\n        <label for=\"inputUsername\">Username</label>\r\n        <input\r\n          type=\"text\"\r\n          name=\"username\"\r\n          class=\"form-control\"\r\n          id=\"inputUsername\"\r\n          placeholder=\"Username\"\r\n          [(ngModel)]=\"impersonatedUser\"\r\n        />\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"inputPassword\">Password</label>\r\n        <input\r\n          type=\"password\"\r\n          name=\"password\"\r\n          class=\"form-control\"\r\n          id=\"inputPassword\"\r\n          placeholder=\"Password\"\r\n          ngModel\r\n        />\r\n      </div>\r\n      <button\r\n        type=\"submit\"\r\n        class=\"btn btn-primary\"\r\n      >\r\n        Login\r\n      </button>\r\n    </form>\r\n    <div>{{ errorMessage }}</div>\r\n  </div>\r\n</div>\r\n\r\n<div>\r\n  <div\r\n    *ngIf=\"showErrorLogin\"\r\n    class=\"middleDiv\"\r\n  >\r\n    <div>Impossibile accedere al sistema. Contattare il servizio di supporto</div>\r\n  </div>\r\n</div>\r\n",
    styles: [".wrapper{display:table;height:100%;width:100%}.wrapper>div{display:table-cell;vertical-align:middle;text-align:center}.wrapper>div>div{display:inline-block}.wrapperCustom{position:relative}.wrapperCustom>div{position:absolute;top:50%;left:50%}body{padding-bottom:1.875rem;background-color:#f7f7f7}.middleDiv{position:absolute;left:50%;margin-left:-8.188rem;margin-top:10%;background-color:#fff;padding:2rem;box-shadow:0 .06rem .19rem #0003,0 .06rem .06rem #00000024,0 .13rem .06rem -.06rem #0000001f;border-radius:.13rem}\n"],
    dependencies: [{
      kind: "directive",
      type: i4.NgIf,
      selector: "[ngIf]",
      inputs: ["ngIf", "ngIfThen", "ngIfElse"]
    }, {
      kind: "directive",
      type: i5.ɵNgNoValidate,
      selector: "form:not([ngNoForm]):not([ngNativeValidate])"
    }, {
      kind: "directive",
      type: i5.DefaultValueAccessor,
      selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]"
    }, {
      kind: "directive",
      type: i5.NgControlStatus,
      selector: "[formControlName],[ngModel],[formControl]"
    }, {
      kind: "directive",
      type: i5.NgControlStatusGroup,
      selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]"
    }, {
      kind: "directive",
      type: i5.NgModel,
      selector: "[ngModel]:not([formControlName]):not([formControl])",
      inputs: ["name", "disabled", "ngModel", "ngModelOptions"],
      outputs: ["ngModelChange"],
      exportAs: ["ngModel"]
    }, {
      kind: "directive",
      type: i5.NgForm,
      selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]",
      inputs: ["ngFormOptions"],
      outputs: ["ngSubmit"],
      exportAs: ["ngForm"]
    }]
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: JwtLoginComponent,
  decorators: [{
    type: Component,
    args: [{
      selector: "lgn-jwt-login",
      standalone: false,
      template: "<div>\r\n  <div\r\n    *ngIf=\"showLoading\"\r\n    class=\"middleDiv\"\r\n  >\r\n    <div>Accesso in corso, attendere...</div>\r\n  </div>\r\n</div>\r\n\r\n<div>\r\n  <div\r\n    *ngIf=\"showLoginMask\"\r\n    class=\"middleDiv\"\r\n  >\r\n    <form\r\n      #loginForm=\"ngForm\"\r\n      (ngSubmit)=\"loginPost(loginForm)\"\r\n    >\r\n      <!-- <div class=\"form-group\">\r\n                <label for=\"inputRealUser\">RealUser</label>\r\n                <input type=\"text\" name=\"realUser\" class=\"form-control\" id=\"inputRealUser\" placeholder=\"RealUser\" [(ngModel)] = \"realUser\">\r\n            </div> -->\r\n      <div class=\"form-group\">\r\n        <label for=\"inputUsername\">Username</label>\r\n        <input\r\n          type=\"text\"\r\n          name=\"username\"\r\n          class=\"form-control\"\r\n          id=\"inputUsername\"\r\n          placeholder=\"Username\"\r\n          [(ngModel)]=\"impersonatedUser\"\r\n        />\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"inputPassword\">Password</label>\r\n        <input\r\n          type=\"password\"\r\n          name=\"password\"\r\n          class=\"form-control\"\r\n          id=\"inputPassword\"\r\n          placeholder=\"Password\"\r\n          ngModel\r\n        />\r\n      </div>\r\n      <button\r\n        type=\"submit\"\r\n        class=\"btn btn-primary\"\r\n      >\r\n        Login\r\n      </button>\r\n    </form>\r\n    <div>{{ errorMessage }}</div>\r\n  </div>\r\n</div>\r\n\r\n<div>\r\n  <div\r\n    *ngIf=\"showErrorLogin\"\r\n    class=\"middleDiv\"\r\n  >\r\n    <div>Impossibile accedere al sistema. Contattare il servizio di supporto</div>\r\n  </div>\r\n</div>\r\n",
      styles: [".wrapper{display:table;height:100%;width:100%}.wrapper>div{display:table-cell;vertical-align:middle;text-align:center}.wrapper>div>div{display:inline-block}.wrapperCustom{position:relative}.wrapperCustom>div{position:absolute;top:50%;left:50%}body{padding-bottom:1.875rem;background-color:#f7f7f7}.middleDiv{position:absolute;left:50%;margin-left:-8.188rem;margin-top:10%;background-color:#fff;padding:2rem;box-shadow:0 .06rem .19rem #0003,0 .06rem .06rem #00000024,0 .13rem .06rem -.06rem #0000001f;border-radius:.13rem}\n"]
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i1$1.Router
  }, {
    type: JwtLoginService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ["loginConfig"]
    }]
  }]
});
class JwtInterceptor {
  loginConfig;
  loginService;
  router;
  constructor(loginConfig, loginService, router) {
    this.loginConfig = loginConfig;
    this.loginService = loginService;
    this.router = router;
  }
  static getToken() {
    // console.log("getToken() : " + JSON.stringify(sessionStorage.getItem("token")));
    return sessionStorage.getItem("token");
  }
  intercept(request, next) {
    // const token = JwtInterceptor.getToken();
    const token = this.loginService.token;
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          Application: this.loginConfig.applicazione
        }
      });
    }
    if (!request.headers.get("krint") && (request.method === "POST" || request.method === "PUT" || request.method === "PATCH" || request.method === "DELETE")) {
      const defaultKrintHeaders = {
        logga: true
      };
      request = request.clone({
        setHeaders: {
          krint: window.btoa(JSON.stringify(defaultKrintHeaders))
        }
      });
    }
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        this.loginService.clearSession();
        this.loginService.redirectTo = this.router.url;
        sessionStorage.setItem("redirectTo", this.loginService.redirectTo);
        this.router.navigateByUrl(this.loginConfig.loginComponentRoute);
        return EMPTY;
      } else {
        return throwError(err);
      }
    }));
    //     map(err => {
    //       let message: string;
    //        //this.toastr.error(`${message}`, "Application Error");
    //        throwError("errore");
    //     })
    //   );
    // catchError(err) => {
    //     // (event: any) => {
    //     //     console.log("TOKEN VALID NO ERROR");
    //     //     if(event instanceof HttpResponse){
    //     //         console.log("TOKEN VALID");
    //     //     // if the token is valid
    //     //     }
    //     // },
    //     // (err: any) => {
    //         console.log("TOKEN NOT VALID ERROR");
    //         // if the token has expired.
    //         if(err instanceof HttpErrorResponse){
    //             if(err.status === 401){
    //                 console.log("TOKEN NOT VALID");
    //                 // this is where you can do anything like navigating
    //             }
    //             this.router.navigateByUrl('/login');
    //         }
    //     }
    // );
    // )
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtInterceptor,
    deps: [{
      token: "loginConfig"
    }, {
      token: JwtLoginService
    }, {
      token: i1$1.Router
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtInterceptor
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: JwtInterceptor,
  decorators: [{
    type: Injectable
  }],
  ctorParameters: () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ["loginConfig"]
    }]
  }, {
    type: JwtLoginService
  }, {
    type: i1$1.Router
  }]
});
var LogoutType;
(function (LogoutType) {
  LogoutType["SSO_SYNC"] = "SSO_SYNC";
  LogoutType["LOCAL"] = "LOCAL";
  LogoutType["DISABLED"] = "DISABLED";
})(LogoutType || (LogoutType = {}));
var IdleState;
(function (IdleState) {
  IdleState[IdleState["NOT_STARTED"] = 0] = "NOT_STARTED";
  IdleState[IdleState["STARTED"] = 1] = "STARTED";
  IdleState[IdleState["TIMEOUT"] = 2] = "TIMEOUT";
  IdleState[IdleState["ERROR"] = 3] = "ERROR";
})(IdleState || (IdleState = {}));
class SessionManager {
  idle;
  keepalive;
  http;
  loginService;
  idleState = IdleState.NOT_STARTED;
  timedOut = false;
  lastPing = null;
  idleSetted = false;
  logoutType;
  _ssoSessionExpired = new Subject();
  // private myLastInterruptMillis: number;
  // private lastInterruptSent: number;
  constructor(idle, keepalive, http, loginService) {
    this.idle = idle;
    this.keepalive = keepalive;
    this.http = http;
    this.loginService = loginService;
  }
  setExpireTokenOnIdle(idleSeconds, pingInterval, logoutRedirectRoute, logoutType) {
    if (!this.idleSetted) {
      const refreshSessionInternautaUrl = this.loginService.getRefreshSessionInternautaUrl();
      const mainApp = this.loginService.getMainApp();
      this.logoutType = logoutType;
      // se sso mettere 8 ore
      if (logoutType === LogoutType.SSO_SYNC) {
        console.log("SSO");
        this.idle.setIdle(10);
      } else {
        console.log("LOCAL");
        this.idle.setIdle(idleSeconds);
      }
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      this.idle.setTimeout(28800);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      // idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
      // this.idle.onIdleStart.subscribe(() => {});
      this.idle.onIdleEnd.subscribe(() => {
        // console.log("No longer Idle");
        if (this.idleState === IdleState.TIMEOUT) {
          this.idleState = IdleState.STARTED;
          // tslint:disable-next-line:max-line-length
        } else if (pingInterval > 0 && window.location.hostname !== "localhost") {
          this.doPing(refreshSessionInternautaUrl, mainApp);
        }
      });
      this.idle.onTimeout.subscribe(() => {
        // sessionStorage.removeItem("token");
        // sessionStorage.removeItem("userinfo");
        if (logoutType === LogoutType.LOCAL) {
          this.loginService.logout(logoutRedirectRoute, true);
        }
        // console.log("sessione scaduta!");
        this.idleState = IdleState.TIMEOUT;
        this.timedOut = true;
        this.idleSetted = false;
        this.reset();
      });
      if (pingInterval && pingInterval > 0 && window.location.hostname !== "localhost") {
        // sets the ping interval
        this.keepalive.interval(pingInterval);
        this.keepalive.onPing.subscribe(() => {
          if (this.idleState !== IdleState.ERROR) {
            this.doPing(refreshSessionInternautaUrl, mainApp);
          }
        });
      }
      this.reset();
      this.idleState = IdleState.STARTED;
      this.idleSetted = true;
    }
  }
  get onTimeOutWarning() {
    return this.idle.onTimeoutWarning;
  }
  get onIdleEnd() {
    return this.idle.onIdleEnd;
  }
  get onIdleStart() {
    return this.idle.onIdleStart;
  }
  isTimePassed(start, end, millis) {
    return end - start >= millis;
  }
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }
  getLogoutType() {
    return this.logoutType;
  }
  get ssoSessionExpired$() {
    return this._ssoSessionExpired.asObservable();
  }
  /**
   * sveglia la sessione Shibboleth e notifica al backend internauta che non siamo in IDLE
   * (chiamando la servlet all'indirizzo refreshSessionInternautaUrl)
   * @param refreshSessionInternautaUrl
   */
  doPing(refreshSessionInternautaUrl, mainApp) {
    this.http.head(window.location.href).subscribe(() => {
      this.lastPing = new Date();
      // se è l'applicazione principale (scrivania) fa il refresh su anche sul backend internauta
      if (mainApp) {
        const logoutUrl = getInternautaUrl(BaseUrlType.Logout);
        this.http.get(refreshSessionInternautaUrl + "?redirectUrl=" + logoutUrl).subscribe(() => {}, error => {
          console.log("errore nella chiamata refresh a internauta");
        });
      }
    }, error => {
      if (this.idleState !== IdleState.ERROR) {
        // console.log("IDLE: ", this.idleState);
        this.idleState = IdleState.ERROR;
        this._ssoSessionExpired.next(true);
        // this.loginService.logout(logoutRedirectRoute, true);
        // window.location.reload();
      }
    });
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SessionManager,
    deps: [{
      token: i1$2.Idle
    }, {
      token: i2$1.Keepalive
    }, {
      token: i1.HttpClient
    }, {
      token: JwtLoginService
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SessionManager,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: SessionManager,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1$2.Idle
  }, {
    type: i2$1.Keepalive
  }, {
    type: i1.HttpClient
  }, {
    type: JwtLoginService
  }]
});
class LoginGuard {
  loginConfig;
  router;
  route;
  loginService;
  sessionManager;
  constructor(loginConfig, router, route, loginService, sessionManager) {
    this.loginConfig = loginConfig;
    this.router = router;
    this.route = route;
    this.loginService = loginService;
    this.sessionManager = sessionManager;
  }
  canActivate(next, state) {
    console.log("LoginGuard - this.loginService.token: ", this.loginService.token);
    const a = this.route;
    //debugger;
    if (!this.loginService.token) {
      // se ho chiesto di andare su una rotta che non è quella di login, la salvo in modo che dopo il login mi può fare il redirect
      if (!(state.url.substring(0, this.loginConfig.loginComponentRoute.length) === this.loginConfig.loginComponentRoute)) {
        // tslint:disable-next-line:max-line-length
        UtilityFunctions.manageChangeUserLogin(state.root.queryParams, this.loginService, this.router, this.loginConfig.loginComponentRoute);
        this.loginService.redirectTo = state.url;
        sessionStorage.setItem("redirectTo", state.url);
      }
      console.log("LoginGuard: redirect to login(), nome: " + this.loginConfig.loginComponentRoute);
      this.router.navigate([this.loginConfig.loginComponentRoute]);
      return false;
    } else {
      // UtilityFunctions.manageChangeUserLogin(state.root.queryParams as Params, this.loginService, this.router, this.loginConfig.loginComponentRoute);
      // se nell'url c'è il passtoken, lo setto nel loginService
      if (state.root.queryParams.hasOwnProperty("passToken")) {
        console.log("setto passToken");
        this.loginService.passToken = state.root.queryParams["passToken"].trim();
      }
      const reloadLoggedUserString = sessionStorage.getItem("reloadLoggedUser");
      console.log("LoginGuard - reloadLoggedUser: ", reloadLoggedUserString);
      const reloadLoggedUser = !reloadLoggedUserString || reloadLoggedUserString === "" || reloadLoggedUserString === "true";
      if (reloadLoggedUser) {
        // sappiamo che e' gia' stato fatto il login, newAccess = false
        // vogliamo ricaricare l'utente connesso, ma non registrare un nuovo accesso
        this.loginService.newUserAccess = false;
        console.log("LoginGuard - loginMethod: ", this.loginService.loginMethod);
        console.log("LoginGuard - impersonateUser(): ", this.loginService.getImpersonateUser());
        console.log("LoginGuard - aziendaImpersonateUser()(): ", this.loginService.getAziendaImpersonateUser());
        if (this.loginService.loginMethod === LoginType.SSO || this.loginService.loginMethod === LoginType.Local) {
          // tslint:disable-next-line:max-line-length
          this.loginService.login(this.loginService.loginMethod, this.loginService.getImpersonateUser(), null, null, this.loginService.getAziendaImpersonateUser(), this.loginService.passToken, this.loginService.code).subscribe(utente => {
            console.log("LoginGuard - new utente: ", utente);
            this.loginService.setLoggedUser$(utente, true);
          });
        }
        sessionStorage.setItem("reloadLoggedUser", "false");
        // eliminazione dalla session storage dell'utente impersonato
        console.log("setto impersonatedUser a '' ");
        this.loginService.setimpersonatedUser(null, null, null);
      }
      if (this.loginConfig.logoutType !== LogoutType.DISABLED) {
        // tslint:disable-next-line:max-line-length
        this.sessionManager.setExpireTokenOnIdle(this.loginConfig.sessionExpireSeconds, this.loginConfig.pingInterval, this.loginConfig.logoutRedirectRoute, this.loginConfig.logoutType);
      }
      return true;
    }
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: LoginGuard,
    deps: [{
      token: "loginConfig"
    }, {
      token: i1$1.Router
    }, {
      token: i1$1.ActivatedRoute
    }, {
      token: JwtLoginService
    }, {
      token: SessionManager
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: LoginGuard
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: LoginGuard,
  decorators: [{
    type: Injectable
  }],
  ctorParameters: () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ["loginConfig"]
    }]
  }, {
    type: i1$1.Router
  }, {
    type: i1$1.ActivatedRoute
  }, {
    type: JwtLoginService
  }, {
    type: SessionManager
  }]
});
class NoLoginGuard {
  loginConfig;
  router;
  loginService;
  constructor(loginConfig, router, loginService) {
    this.loginConfig = loginConfig;
    this.router = router;
    this.loginService = loginService;
  }
  canActivate(next, state) {
    if (!this.loginService.token) {
      return true;
    } else {
      this.router.navigate([this.loginConfig.homeComponentRoute]);
      return false;
    }
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NoLoginGuard,
    deps: [{
      token: "loginConfig"
    }, {
      token: i1$1.Router
    }, {
      token: JwtLoginService
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NoLoginGuard
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: NoLoginGuard,
  decorators: [{
    type: Injectable
  }],
  ctorParameters: () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ["loginConfig"]
    }]
  }, {
    type: i1$1.Router
  }, {
    type: JwtLoginService
  }]
});
class RefreshLoggedUserGuard {
  router;
  loginService;
  route;
  constructor(router, loginService, route) {
    this.router = router;
    this.loginService = loginService;
    this.route = route;
  }
  canActivate(next, state) {
    console.log("RefreshLoggedUserGuard - this.loginService.token: ", this.loginService.token);
    // debugger;
    if (!this.loginService.token) {
      const tokenString = sessionStorage.getItem("token");
      console.log("tokenString: ", tokenString);
      if (tokenString && tokenString !== "") {
        this.loginService.token = tokenString;
      }
      const loginMethodString = sessionStorage.getItem("loginMethod");
      if (loginMethodString && loginMethodString !== "") {
        this.loginService.loginMethod = UtilityFunctions.getLoginTypeFromSessionStorageString(loginMethodString);
      }
      const redirectToString = sessionStorage.getItem("redirectTo");
      if (redirectToString && redirectToString !== "") {
        this.loginService.redirectTo = redirectToString;
      }
      const reloadLoggedUserString = sessionStorage.getItem("reloadLoggedUser");
      console.log("RefreshLoggedUserGuard - reloadLoggedUser: ", reloadLoggedUserString);
      const reloadLoggedUserIsFalse = reloadLoggedUserString === "false";
      if (reloadLoggedUserIsFalse) {
        const loggedUserString = sessionStorage.getItem("loggedUser");
        if (loggedUserString && loggedUserString !== "") {
          const loggedUser = UtilityFunctions.buildLoggedUser(JSON.parse(loggedUserString));
          console.log("RefreshLoggedUserGuard - new utente: ", loggedUser);
          this.loginService.setLoggedUser$(loggedUser);
        }
      }
      const newUserAccessString = sessionStorage.getItem("newUserAccess");
      if (newUserAccessString) {
        this.loginService.newUserAccess = newUserAccessString === "true";
      } else {
        this.loginService.newUserAccess = true;
      }
    }
    return true;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: RefreshLoggedUserGuard,
    deps: [{
      token: i1$1.Router
    }, {
      token: JwtLoginService
    }, {
      token: i1$1.ActivatedRoute
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: RefreshLoggedUserGuard
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: RefreshLoggedUserGuard,
  decorators: [{
    type: Injectable
  }],
  ctorParameters: () => [{
    type: i1$1.Router
  }, {
    type: JwtLoginService
  }, {
    type: i1$1.ActivatedRoute
  }]
});
class LoggedOutPageComponent {
  constructor() {}
  ngOnInit() {}
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: LoggedOutPageComponent,
    deps: [],
    target: i0.ɵɵFactoryTarget.Component
  });
  /** @nocollapse */
  static ɵcmp = i0.ɵɵngDeclareComponent({
    minVersion: "14.0.0",
    version: "19.0.6",
    type: LoggedOutPageComponent,
    isStandalone: false,
    selector: "lgn-logged-out-page",
    ngImport: i0,
    template: "<p>E' stato effettuato il logout</p>\r\n",
    styles: [""]
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: LoggedOutPageComponent,
  decorators: [{
    type: Component,
    args: [{
      selector: "lgn-logged-out-page",
      standalone: false,
      template: "<p>E' stato effettuato il logout</p>\r\n"
    }]
  }],
  ctorParameters: () => []
});

// import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
class JwtLoginModule {
  /** Un modulo, per convenzione, si inizializza tramite un metodo statico chiamato forRoot.
   * Al metodo forRoot è possibile passare dei parametri.
   * @param loginConfig parametro di configurazione del modulo
   * @returns il modulo inizializzato
   */
  static forRoot(loginConfig) {
    return {
      ngModule: JwtLoginModule,
      /**
       * si definiscono i service del modulo
       */
      providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true
      }, JwtLoginService, LoginGuard, NoLoginGuard, RefreshLoggedUserGuard, SessionManager,
      // tslint:disable-next-line:max-line-length
      {
        provide: "loginConfig",
        useValue: loginConfig
      } // in questo modo si definisce la variabile loginConfig in modo da porterla iniettare all'interno dei service
      ]
    };
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtLoginModule,
    deps: [],
    target: i0.ɵɵFactoryTarget.NgModule
  });
  /** @nocollapse */
  static ɵmod = i0.ɵɵngDeclareNgModule({
    minVersion: "14.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtLoginModule,
    declarations: [JwtLoginComponent, LoggedOutPageComponent],
    imports: [CommonModule, FormsModule],
    exports: [JwtLoginComponent, LoggedOutPageComponent]
  });
  /** @nocollapse */
  static ɵinj = i0.ɵɵngDeclareInjector({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JwtLoginModule,
    providers: [provideHttpClient(withInterceptorsFromDi())],
    imports: [CommonModule, FormsModule]
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: JwtLoginModule,
  decorators: [{
    type: NgModule,
    args: [{
      declarations: [JwtLoginComponent, LoggedOutPageComponent],
      exports: [JwtLoginComponent, LoggedOutPageComponent],
      imports: [CommonModule, FormsModule],
      providers: [provideHttpClient(withInterceptorsFromDi())]
    }]
  }]
});

/*
 * Public API Surface of jwt-login
 */

/**
 * Generated bundle index. Do not edit.
 */

export { JwtLoginComponent, JwtLoginModule, JwtLoginService, LoggedOutPageComponent, LoginGuard, LoginType, LogoutType, NoLoginGuard, RefreshLoggedUserGuard, SessionManager, UtenteUtilities, UtilityFunctions };
